<div class="label">UNITS</div>
<div class="values">
  <span [matTooltip]="'Available  Units'">{{ $any(units)?.availableUnits | number : numberFormat }}</span>
  <ng-container *ngIf="$any(units)?.assignedUnits">
    /
    <span matTooltip="Assigned Units"> {{ $any(units)?.assignedUnits | number : numberFormat }}</span>
  </ng-container>
  <ng-container *ngIf="$any(units)?.completedUnits">
    /
    <span matTooltip="Completed Units">{{ $any(units)?.completedUnits | number : numberFormat}}</span>
  </ng-container>
</div>
